import { Box, Link, Stack, Typography, makeStyles } from "@mui/material";
import { SupportTempProps } from "./Support";
import { ButtonCust } from "../../widgets";
import EnvConfig from "../../../config/env.config.json";
import { useNavigate } from "react-router-dom";
import { RoutingURLs } from "../../../config/RoutingURLs";

const SupportComponent = (props: SupportTempProps) => {
  const { content } = props.content;
  const navigate = useNavigate();

  return (
    <Stack sx={{ background: "var(--bright-grey)" }}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-around",
          alignItems: { xs: "center", md: "center" },
          width: "70%",
          margin: "0 auto",
          p: { xs: "25px 0px 31px", sm: "35px" },
          gap: { xs: "20px", md: "unset" },
          flexDirection: { xs: "column", md: "row" },
        }}
      >
        <Typography
          component={"span"}
          sx={{
            fontFamily: {
              xs: "var(--font_family_Bold)",
              sm: "var(--font_family_Semibold)",
            },
            fontWeight: {
              xs: "var(--font_weight_4)",
              sm: "var(--font_weight_2)",
            },
            color: "var(--title-color_1)",
            fontSize: "24px",
          }}
        >
          {content.title}
        </Typography>
        <Typography component={"span"} sx={{ display: "flex", gap: "60px" }}>
          <Typography
            component={"span"}
            sx={{
              fontFamily: {
                xs: "var(--font_family_Medium)",
                md: "var(--font_family_Semibold)",
              },
              color: "var(--title-color_1)",
              fontSize: { xs: "14px", sm: "18px" },
              fontWeight: "var(--font_weight_2)",
            }}
          >
            {content.support}
          </Typography>
          <Typography
            component={"span"}
            sx={{
              fontFamily: {
                xs: "var(--font_family_Medium)",
                md: "var(--font_family_Semibold)",
              },
              color: "var(--title-color_1)",
              fontSize: { xs: "14px", sm: "18px" },
              fontWeight: {
                xs: "var(--font_weight_4)",
                sm: "var(--font_weight_2)",
              },
            }}
          >
            <Link
              href={`tel:${content.contact}`}
              sx={{
                color: "var(--title-color_1)",
                textDecoration: "none",
                fontFamily: "inherit",
              }}
            >
              {content.contact}
            </Link>
          </Typography>
        </Typography>
        <ButtonCust
          sx={{
            width: { xs: "200px", md: "200px" },
            mt: { xs: "10px", sm: "0px" },
          }}
          variantType={EnvConfig.PRIMARY_BUTTON_TYPE}
          onClick={() => navigate(RoutingURLs.help)}
        >
          {content.button}
        </ButtonCust>
      </Box>
    </Stack>
  );
};

export default SupportComponent;
